import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateUploadRequestsInput } from '@peles/shared';
import { createUploadRequests } from '../api/uploadRequests';

/**
 * Ask people for files about a record. The record's attachment list is
 * refreshed afterwards — what was asked for shows there once it arrives, and
 * a page left open should not need a reload to find it.
 */
export function useCreateUploadRequests() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateUploadRequestsInput) => createUploadRequests(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['entity-attachments'] });
    },
  });
}
